import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { GeneratedResponse } from "./types";

interface GeneratedResponsesState {
  generatedResponses: GeneratedResponse[];
  addResponse: (response: GeneratedResponse) => void;
  removeResponse: (response: GeneratedResponse[]) => void;
}

export const useGeneratedResponsesStore = create<GeneratedResponsesState>()(
  persist(
    (set) => ({
      generatedResponses: [],
      addResponse: (response: GeneratedResponse) =>
        set((state) => ({
          generatedResponses: [response, ...state.generatedResponses],
        })),
      removeResponse: (response: GeneratedResponse[]) =>
        set((state) => ({
          generatedResponses: response,
        })),
    }),
    {
      name: "generated-responses", // Key for localStorage
      storage: createJSONStorage(() => localStorage), // Use createJSONStorage to adapt localStorage
    }
  )
);
